<template>
  <div id="session-sign-up">
    <div v-if="!loading" class="infos w-100" style="max-width: 1000px">
      <MessageList
        :messages="responseMessage.messages"
        :status="responseMessage.status"
      />
      <SignUpForm
        v-if="!hideForm"
        class="w-100"
        :organizations="organizations || []"
        :with-organization="fromQr"
        :need-organization="fromQr"
        with-password
        is-open-site
        @signup="signup"
      />
    </div>
    <i v-else class="pi pi-spin pi-spinner"></i>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, reactive } from "vue";
import {
  useAuthorize,
  useRouterUtil,
  useOrganizations,
} from "/@/vue/composables";
import { MessageList } from "/@/vue/components/Atom";
import { SignUpForm } from "/@/vue/components/Organisms";
import { MessageStatus, SingUpResponse, User } from "/@/types";

// util

const { goto, currentRouteQuery } = useRouterUtil();
const fromQr = computed<boolean>(() => {
  return currentRouteQuery.value.from_qr === "true";
});

// organization

const { getOrganizations } = useOrganizations();
const { data: organizations } = getOrganizations({
  branch: true,
});

// core

const loading = ref<boolean>(false);
const responseMessage = reactive<{
  messages: Array<string>;
  status?: MessageStatus;
}>({
  messages: [],
});

const { signup: userSignup } = useAuthorize();
const signUpResult = ref<SingUpResponse>();

const hideForm = computed<boolean>(() => {
  return (
    signUpResult.value?.status == "confirm" ||
    signUpResult.value?.status == "success"
  );
});

async function signup(userForm: User) {
  loading.value = true;

  signUpResult.value = await userSignup(userForm, { fromQr: fromQr.value });

  switch (signUpResult.value.status) {
    case "reconfirm":
      responseMessage.messages = [
        "認証用のメールを再送信しました。24時間以内にメールを認証して下さい。",
      ];
      responseMessage.status = "success";
      break;
    case "confirm":
      responseMessage.messages = [
        "アカウントを作成し認証用のメールを送信しました。24時間以内にメールを認証して下さい。",
      ];
      responseMessage.status = "success";
      break;
    case "error":
      responseMessage.messages = [
        "アカウント作成に失敗しました。メールアドレスが既に使用されています。ログイン・またはメールアドレスの認証を行って下さい。",
      ];
      responseMessage.status = "error";
      break;
    case "success":
      responseMessage.messages = [
        "アカウントを作成し認証用のメールを送信しました。24時間以内にメールを認証して下さい。",
      ];
      responseMessage.status = "success";
      break;
  }

  loading.value = false;
}
</script>

<style scoped lang="scss">
#session-sign-up {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100vw;
}
</style>
